import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, inject, reactive, computed, getCurrentInstance } from 'vue'
import { useQuery, useQueryLoading, useSubscription, useApolloClient } from '@vue/apollo-composable'
import moment from "moment"
import MyWorkList from '@/components/MyWorkList.vue'
import MyWorkStats from '@/components/MyWorkStats.vue'
import NotificationsWidget from '@/components/NotificationsWidget.vue'
import CountJobs from "@/graphql/job/countJobs.graphql"
import EntityEventSubscription from "@/graphql/subscription/entityevent.graphql"
import { iosWrapperClient } from "@/helpers"
import { User } from "@coredination/common"
import MeQuery from "@coredination/components/src/graphql/user/me.graphql"
import { useI18n } from '@/i18n'
import router from "@/router"

/*Vue 3 
defineOptions({
    name: 'Home'
})
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
const router = useRouter()
const route = useRoute()
*/


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const { t } = useI18n()
const { result: meResult, onResult: onMeResult } = useQuery(MeQuery)
const me = computed(() => {
  if (!meResult.value?.me) return new User({});
  return new User(meResult.value.me);
})

//Vue 2.7
const searchQuery = ref("")
const searchInputTimeout = ref<any>(null)
const inhibitSubscription = computed(() => localStorage && !!localStorage.getItem("inhibitSubscription"))
const show = ref(false)
const myWorkList = ref(null)
const myWorkStats = ref(null)

const untimedJobStates = [
    "INITIAL",
    "DRAFT",
    "PUBLISHED",
    "ASSIGNED",
    "SCHEDULED",
    "IN_TRANSIT",
    "ON_STATION",
    "PAUSED",
    "DAY_FINISHED",
    "FINISHED",
    "STARTED",
]

const lateJobStates = [
    "PUBLISHED",
    "ASSIGNED",
    "SCHEDULED",
    "ACCEPTED",
]

onMounted(() => {
    // Should not be necessary since we have cache handling, but for safety while we switch to Vue 3.
    refresh()
})

const { result: lateJobsCountResult, refetch: refetchLateJobsCount } = useQuery(CountJobs, {
    states: lateJobStates,
    hideOldFinished: true,
    from: moment().startOf("day"),
    to: moment(),
    current: true,
    onlyLate: true,
    filterParams: { type: "list", value: "mine" },
}, { pollInterval: 300000, fetchPolicy: 'no-cache' })

const { result: untimedJobsCountResult, refetch: refetchUntimedJobsCount } = useQuery(CountJobs, {
    states: untimedJobStates,
    onlyUntimed: true,
    hideOldFinished: true,
    filterParams: { type: "list", value: "mine" },
}, { pollInterval: 300000, fetchPolicy: 'no-cache' })

const lateJobsCount = computed(() => lateJobsCountResult.value?.countJobs)
const untimedJobsCount = computed(() => untimedJobsCountResult.value?.countJobs)

const { onResult: onEntityEventResult } = useSubscription(EntityEventSubscription, null, {enabled: !inhibitSubscription.value})

onEntityEventResult((result: any) => {
    console.log("onEntityEventResult")

    const event = result.data.entityEvent
    console.log("WORKS", event.type, event.data)
    if (shouldRefresh(event)) {
        myWorkStats.value?.refresh()
        refreshCounts()
    }
})

const fabOptions = computed(() => [
    {
        title: t("createNewJob"),
        to: "/job/new?me&today",
        if: () => me.value && me.value.hasFeature("jobs") && me.value.hasPermissionInPrimaryGroup("create_jobs") && me.value.hasPermission("create_jobs")
    },
    {
        title: t("reportWorkStandAlone"),
        to: "/workreport/new",
        if: () => me.value && me.value.hasFeature("work_reports") && me.value.hasPermissionInPrimaryGroup("do_work")
    },
    {
        title: t("reportAbsence"),
        to: "/workreport/absence/new",
        if: () => me.value && me.value.hasFeature("absence") && me.value.hasPermissionInPrimaryGroup("do_work")
    }
])


const shouldRefresh = (entityEvent: any) => {
    let entity: any = entityEvent.data
    let entityClass: string = entity.entityClass
    if (!['WorkReport', 'Job'].includes(entityClass))
        return false
    if (me.value.id && entity.userId === me.value.id)
        return true
    if (entity.jobResourceUserIds)
        return entity.jobResourceUserIds.includes(parseInt(me.value.id))
    return false
}

const refresh = () => {
    myWorkList.value?.refresh()
    myWorkStats.value?.refresh()
    refreshCounts()
}

const refreshCounts = () => {
    refetchLateJobsCount()
    refetchUntimedJobsCount()
}

const searchInput = () => {
    if (searchInputTimeout.value) clearTimeout(searchInputTimeout.value)
    searchInputTimeout.value = setTimeout(() => {
        search()
    }, 500)
}

const search = () => {
    if (searchInputTimeout.value) clearTimeout(searchInputTimeout.value)
    router.push({ name: "search", params: { q: searchQuery.value } })
    searchInputTimeout.value = null
}


return { __sfc: true,t, meResult, onMeResult, me, searchQuery, searchInputTimeout, inhibitSubscription, show, myWorkList, myWorkStats, untimedJobStates, lateJobStates, lateJobsCountResult, refetchLateJobsCount, untimedJobsCountResult, refetchUntimedJobsCount, lateJobsCount, untimedJobsCount, onEntityEventResult, fabOptions, shouldRefresh, refresh, refreshCounts, searchInput, search, MyWorkList, MyWorkStats, NotificationsWidget, iosWrapperClient }
}

})